import BossModel from "@/models/BossModel";
import Product from '@/models/Product/Product';
import Package from '@/models/Package/Package';

export default class WebsiteIncludeTransfer extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-include-transfer';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteincludetransfers';

    static fields() {
		return {
			id: this.number(null).nullable(),
			product_id: this.number(null).nullable(),
			package_id: this.number(null).nullable(),
			include_transfer_cid: this.attr(null),
            product: this.belongsTo(Product, 'product_id'),
            package: this.belongsTo(Package, 'package_id'),
		}
	}

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     */
    static options() {
        return this.api().action('options').getSingle(false);
    }

    /**
     *
     * @param packageId
     * @param cids
     * @returns {Promise<AxiosResponse<T>>}
     */
    static updatePackage(packageId, cids) {
        return this.api().action('package/' + packageId)
            .updateMultiple({include_transfer_cids: cids}, true).then(() => {
                return this.api().with().find(this.id);
            });
    }

    /**
     *
     * @param productId
     * @param cids
     * @returns {Promise<AxiosResponse<T>>}
     */
    static updateProduct(productId, cids) {
        return this.api().action('product/' + productId)
            .updateMultiple({include_transfer_cids: cids}, true);
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    Product() {
        return this.getRelated('product');
    }

    /**
     * @returns { Package }
     */
    Package() {
        return this.getRelated('package');
    }
}
